<div class="object-header">
  <gc-text [variant]="'minorHeading'">{{ address() }}</gc-text>
  @if (isNotApplicable()) {
    <gc-tag class="not-applicable-tag">{{
      'buildingPageModal.sectionNotApplicable.tag' | translate
    }}</gc-tag>
  }
</div>
